/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function VideoHeader(elem) {
        Behaviors.init(VideoHeader, this, arguments);


        var $thisElem = this.$elem;

        var $thisElemVideo = this.$elem.find("[data-video-header]");
        var $thisElemVideoIframe = this.$elem.find("[data-iframe-header]");

        var pageLoaderExists = $('.PageLoader-overlay_animation_content').length;
        var animationItem = $('.VideoHeader-overlay_animation_content_item');

        // $thisElem.addClass("VideoHeader--start_heading_animation");

        var delayVideoTime = animationItem.length + '000';

        // setTimeout(function() {
        //     $thisElem.addClass("VideoHeader--start_animation");
        // }, 3000);

        if($thisElemVideo.length > 0) {
            if (pageLoaderExists > 0) {
                var video = $thisElemVideo;
                setTimeout(function() {
                video[0].play();
                }, delayVideoTime);
            } else {
                var video = $thisElemVideo;
                setTimeout(function() {
                video[0].play();
                }, 10);
            };
        }

    }
    Behaviors.inherit(VideoHeader, Behaviors.Behavior);
    VideoHeader.QUERY = "[data-video-header-par]";
    Behaviors.register_behavior(VideoHeader);
    module.VideoHeader = VideoHeader;
    return module;
}(window.jQuery, window.Behaviors));